<template>

    <form ref="estoqueitem-form-edit" v-on:submit.prevent="executeEdit(model)" novalidate>

        <div class="row">
            <div class="form-group col-md-12">
                <label for="nome">Nome</label>
                <input type="text" class="form-control" maxlength="150" name="nome" placeholder="Nome" v-model="model.nome" />
            </div>
            <div class="form-group col-md-12">
                <label for="descricao">Descrição</label>
                <textarea type="text" class="form-control" name="descricao" placeholder="Descrição" v-model="model.descricao" />
            </div>
            <div class="form-group col-md-12">
                <label for="referenciaCNAStore">Referência CNA Store</label>
                <input type="text" class="form-control" maxlength="50" name="referenciaCNAStore" placeholder="ReferenciaCNAStore" v-model="model.referenciaCNAStore" />
            </div>
            <div class="form-group col-md-12">
                <label for="unidadeMedidaId">Unidade de Medida</label>
                <select v-select="{ dataitem: 'UnidadeMedida', default: 'Todos' }" v-model="model.unidadeMedidaId" class="form-control" name="unidadeMedidaId"></select>
            </div>
            <div class="form-group col-md-12">
                <label for="categoriaEstoqueId">Categoria de Estoque</label>
                <select v-select="{ dataitem: 'CategoriaEstoque', default: 'Todos' }" v-model="model.categoriaEstoqueId" class="form-control" name="categoriaEstoqueId"></select>
            </div>
            <div class="form-group col-md-12">
                <div class="clearfix">&nbsp;</div>
                <label class="custom-control custom-checkbox">
                    <input type="checkbox" name="ativo" class="custom-control-input" v-model="model.ativo">
                    <span class="custom-control-indicator"></span>
                    <span class="custom-control-description"> Ativo?</span>
                </label>
            </div>
            <div class="form-group col-md-12">
                <div class="clearfix">&nbsp;</div>
                <label class="custom-control custom-checkbox">
                    <input type="checkbox" name="venda" class="custom-control-input" v-model="model.venda">
                    <span class="custom-control-indicator"></span>
                    <span class="custom-control-description"> Venda?</span>
                </label>
            </div>
            <div class="form-group col-md-12">
                <div class="clearfix">&nbsp;</div>
                <label class="custom-control custom-checkbox">
                    <input type="checkbox" name="compraViaCNAStore" class="custom-control-input" v-model="model.compraViaCNAStore">
                    <span class="custom-control-indicator"></span>
                    <span class="custom-control-description"> Compra SOMENTE Via CNA Store? </span>
                    <i class="fa fa-info-circle" placement="top" v-b-tooltip title="Não marque esta opção se o material didático puder ser comprado por fora da CNA Store"></i>
                </label>
            </div>
            <div class="form-group col-md-12">
                <div class="clearfix">&nbsp;</div>
                <label class="custom-control custom-checkbox">
                    <input type="checkbox" name="vendaShoppingCNA" class="custom-control-input" v-model="model.vendaShoppingCNA">
                    <span class="custom-control-indicator"></span>
                    <span class="custom-control-description"> Venda SOMENTE Via Shopping CNA? </span>
                    <i class="fa fa-info-circle" placement="top" v-b-tooltip title="Marque esta opção se o material didático puder ser comprado Shopping CNA"></i>
                </label>
            </div>
            <div class="form-group col-md-12">
                <div class="clearfix">&nbsp;</div>
                <label class="custom-control custom-checkbox">
                    <input type="checkbox" name="ehMaterialDigital" class="custom-control-input" v-model="model.ehMaterialDigital">
                    <span class="custom-control-indicator"></span>
                    <span class="custom-control-description"> É material digital?</span>
                </label>
            </div>
        </div>

        <button type="button" class="btn btn-default" @click="onBack()">
            <span>Voltar</span>
        </button>
        <button type="button" class="btn btn-success float-right" @click="executeEdit(model)">
            <span>Salvar</span>
        </button>

    </form>


</template>
<script>

    import base from '@/common/base.js'
    import { Api } from '@/common/api'

    export default {
        name: "estoqueitem-form-edit",
        mixins: [base],
        props: { id: Number },
        data: () => ({

            model: {},

            form: "estoqueitem-form-edit",

            resources: {
                edit: 'estoqueitem',
            },

        }),

        methods: {

            executeEdit: function (model) {

                if (this.formValidate() == false) return;

                new Api(this.resources.edit).put(model).then(data => {
                    this.defaultSuccessResult("Edição realizada com sucesso");
                    this.$emit('on-saved', data)
                }, err => {
                    this.defaultErrorResult(err);
                })
            },

            formValidate: function () {
                var $form = this.$refs[this.form];
                $form.classList.add("was-validated");
                return $form.checkValidity();
            },

            onBack: function () {
                this.$emit('on-back')
            }
        },

        mounted() {
            new Api(this.resources.edit).get({ estoqueItemId: this.id }).then(data => {
                if (data.data) this.model = data.data;
                else if (!data.dataList) this.model = {};
                else if (data.dataList.length == 1) this.model = data.dataList[0];
                else this.model = {};
            }, err => {
                this.defaultErrorResult(err);
            })
        }
    };
</script>